module.exports = __webpack_public_path__ + "media/images/ee_flag-65f4a3d8a979c3ca5a96b32404d2010e.svg";